import * as React from 'react';
import { SignupPage } from './SignupPage';
import { SignupPageProvider } from './SignupContext';

interface SignupPageRootProps {
  formId: string;
  pageNotFound?: boolean;
}

export const SignupPageRoot: React.FC<SignupPageRootProps> = props => {
  return (
    <SignupPageProvider>
      <SignupPage {...props} />
    </SignupPageProvider>
  );
};
